var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`icon${_vm._variant ? ` ${_vm._variant}` : ''} ${_vm.size}`},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.stayIcons.icons(_vm._value).svg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }